// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nv-c";
export var backButton = "_nv-4";
export var backIcon = "_nv-5";
export var chevronShortcut = "_nv-6";
export var container = "_nv-1";
export var editor = "_nv-8";
export var editorWrapper = "_nv-7";
export var prefix = "_nv-2";
export var searchIcon = "_nv-3";
export var suffix = "_nv-9";
export var suffixContent = "_nv-a";
export var suffixText = "_nv-b";
export var wrapper = "_nv-0";